<template>
  <div>
    <div v-if="profession" class="graduates-professions">
      <div
        class="graduates-professions-text"
        v-html="profession[$t('key')]"
      ></div>
      <a
        href="#"
        class="graduates-professions-symbol close"
        @click.prevent="reset"
      >
        <v-icon :size="35" color="#000">mdi-close</v-icon>
      </a>
    </div>
    <a
      v-else
      href="#"
      :class="`graduates-professions${value ? ' is-active' : ''}`"
      @click.prevent="$emit('input', !value)"
    >
      <div class="graduates-professions-text">
        {{ $t('home.choose_profession') }}
      </div>
      <div class="graduates-professions-symbol">
        <v-icon :size="35" color="#000">mdi-chevron-down</v-icon>
      </div>
    </a>
  </div>
</template>

<script>
export default {
  props: {
    value: Boolean
  },
  computed: {
    profession() {
      return this.$store.getters['graduates/profession']
    }
  },
  methods: {
    reset() {
      this.$store.dispatch('graduates/filter', null)
      this.$store.dispatch('graduates/resetLimit')
    }
  }
}
</script>

<style lang="scss">
@import '~vuetify/src/styles/styles.sass';

.graduates-professions {
  display: inline-flex;

  border: solid 2px #000;

  color: #000 !important;
  text-decoration: none;

  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    width: 100%;
  }

  &:hover,
  &.is-active {
    .graduates-professions-symbol:not(.close) {
      background: #5a7bff;
    }

    .graduates-professions-symbol.close {
      background: #ff0079;
    }
  }
}

.graduates-professions-text {
  padding: 0 24px;

  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    flex-grow: 1;
  }
}

.graduates-professions-symbol {
  width: 45px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-left: solid 2px #000;
  text-decoration: none;
  transition: background 0.2s;

  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    .v-icon {
      font-size: 27px !important;
    }
  }
}
</style>
